/**
 * Party shell `id` from `/api/catalog/party/games/` → `/api/modes/<segment>/` URL segment (kebab-case).
 * @see FRONTEND_MODES_BY_APP.md
 */
const SHELL_TO_MODE_SEGMENT: Record<string, string> = {
  imposter: "imposter",
  "imposter-online": "imposter",
  guess: "guess",
  act: "acting",
  who: "whoami",
  fast: "quick-questions",
  category: "category",
  challenge: "dare",
  bluff: "answer-bluff",
};

export function partyShellIdToModePathSegment(shellId: string): string {
  return SHELL_TO_MODE_SEGMENT[shellId] ?? shellId.replace(/_/g, "-");
}

/** Registry `slug` uses underscores; URLs use hyphens. */
export function modeRegistrySlugToPathSegment(slug: string): string {
  return slug.replace(/_/g, "-");
}
